import { createReducer } from '@ngrx/store';

export interface AiDataModelGenerationState {}

export const initialState: AiDataModelGenerationState = {};

export const aiDataModelGenerationReducer = createReducer<AiDataModelGenerationState>(initialState);
